// OP-3619 — Foto de comprovante tirada no celular, reduzida antes de subir.
//
// A câmera do celular entrega de 3 a 12 MB; o servidor aceita até 8 MB, e em
// campo a conexão é móvel. Um comprovante precisa ser legível, não impresso:
// com o lado maior em 2000 px e JPEG a 0,8 ele fica com algumas centenas de KB.
// Se o navegador não conseguir reduzir, o arquivo original segue.

export const LADO_MAXIMO = 2000
const QUALIDADE = 0.8
const REDUZIR_ACIMA_DE_BYTES = 1.5 * 1024 * 1024

export function dimensoesReduzidas(largura: number, altura: number, maximo = LADO_MAXIMO): { largura: number; altura: number } {
  const maior = Math.max(largura, altura)
  if (maior <= maximo || maior <= 0) return { largura, altura }
  const fator = maximo / maior
  return { largura: Math.round(largura * fator), altura: Math.round(altura * fator) }
}

export function precisaReduzir(arquivo: { type: string; size: number }, largura: number, altura: number): boolean {
  if (arquivo.type.indexOf('image/') !== 0 || arquivo.type === 'image/gif') return false
  return arquivo.size > REDUZIR_ACIMA_DE_BYTES || Math.max(largura, altura) > LADO_MAXIMO
}

export async function comprimirFoto(arquivo: File): Promise<File> {
  if (arquivo.type.indexOf('image/') !== 0 || typeof createImageBitmap !== 'function') return arquivo
  try {
    const bitmap = await createImageBitmap(arquivo, { imageOrientation: 'from-image' } as unknown as ImageBitmapOptions)
    try {
      if (!precisaReduzir(arquivo, bitmap.width, bitmap.height)) return arquivo
      const { largura, altura } = dimensoesReduzidas(bitmap.width, bitmap.height)
      const canvas = document.createElement('canvas')
      canvas.width = largura
      canvas.height = altura
      const ctx = canvas.getContext('2d')
      if (!ctx) return arquivo
      ctx.drawImage(bitmap, 0, 0, largura, altura)
      const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, 'image/jpeg', QUALIDADE))
      if (!blob || blob.size >= arquivo.size) return arquivo
      const nome = arquivo.name.replace(/\.[^.]+$/, '') || 'comprovante'
      return new File([blob], `${nome}.jpg`, { type: 'image/jpeg' })
    } finally {
      bitmap.close()
    }
  } catch {
    return arquivo
  }
}
